<template>
    <div class="our-mission-area ptb-100">
        <div class="container-fluid">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-12">
                    <div class="our-mission-content">
                        <div class="content">
                            <span class="sub-title"><img src="../../assets/images/star-icon.png" alt="image"> Our Mission</span>
                            <h2>Data Science & Data Analysis Agency</h2>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.</p>
                            <ul class="our-mission-list">
                                <li>
                                    <span>
                                        <div class="icon">
                                            <i class="flaticon-tick"></i>
                                        </div>
                                        Global Experience
                                        <img src="../../assets/images/our-mission/our-mission-shape2.png" alt="image">
                                    </span>
                                </li>
                                <li>
                                    <span>
                                        <div class="icon">
                                            <i class="flaticon-tick"></i>
                                        </div>
                                        Value for Results
                                        <img src="../../assets/images/our-mission/our-mission-shape2.png" alt="image">
                                    </span>
                                </li>
                                <li>
                                    <span>
                                        <div class="icon">
                                            <i class="flaticon-tick"></i>
                                        </div>
                                        User Prespective
                                        <img src="../../assets/images/our-mission/our-mission-shape2.png" alt="image">
                                    </span>
                                </li>
                                <li>
                                    <span>
                                        <div class="icon">
                                            <i class="flaticon-tick"></i>
                                        </div>
                                        Business Prespective
                                        <img src="../../assets/images/our-mission/our-mission-shape2.png" alt="image">
                                    </span>
                                </li>
                                <li>
                                    <span>
                                        <div class="icon">
                                            <i class="flaticon-tick"></i>
                                        </div>
                                        Expert Prepective
                                        <img src="../../assets/images/our-mission/our-mission-shape2.png" alt="image">
                                    </span>
                                </li>
                                <li>
                                    <span>
                                        <div class="icon">
                                            <i class="flaticon-tick"></i>
                                        </div>
                                        Retail Solutions
                                        <img src="../../assets/images/our-mission/our-mission-shape2.png" alt="image">
                                    </span>
                                </li>
                            </ul>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.</p>
                            <router-link to="/about-us-two" class="default-btn"><i class="flaticon-right"></i>Read More<span></span></router-link>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 col-md-12">
                    <div class="our-mission-image">
                        <img src="../../assets/images/our-mission/our-mission1.png" alt="image">
                        <div class="shape"><img src="../../assets/images/our-mission/our-mission-shape1.png"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'DataScience'
}
</script>